import { ApolloError, BaseQueryOptions } from '@apollo/client';
import { FirestoreUser, useFirestoreUserQuery } from 'generated/graphql';

function useGetUser(
    id: string,
    organizationId: string,
    options?: BaseQueryOptions,
): {
    qualityUser: Partial<FirestoreUser>;
    loading: boolean;
    error: ApolloError;
} {
    const {
        data: user,
        loading,
        error,
    } = useFirestoreUserQuery({
        ...options,
        fetchPolicy: 'no-cache',
        variables: {
            where: {
                instanceId: organizationId,
                uid: id,
            },
        },
    });

    return {
        qualityUser: user?.firestoreUser || null,
        loading,
        error,
    };
}

export default useGetUser;
